import { Label } from "layout/typography/Label";
import { Chips } from "primereact/chips";
import { useState, useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form";
import styled from "styled-components";

const Title = styled.h3`
  margin-bottom: 16px;
`;

export function MemberIdPrefixes() {
  const { control, watch } = useFormContext();
  const [memberIdPrefixes, setMemberIdPrefixes] = useState<string[]>([]);
  const watchedMemberIdPrefixes = watch("memberIdPrefixes");

  useEffect(() => {
    if (watchedMemberIdPrefixes) {
      setMemberIdPrefixes(watchedMemberIdPrefixes);
    }
  }, [watchedMemberIdPrefixes]);

  return (
    <div className="block bg-white border-round p-4 mb-4">
      <Title>Member ID Starts With</Title>
      <Label htmlFor="memberIdPrefixes">Add Member ID Prefixes</Label>
      <Controller
        name="memberIdPrefixes"
        control={control}
        render={({ field: { onChange } }) => (
          <Chips
            id="memberIdPrefixes"
            value={memberIdPrefixes}
            className="w-full mt-2"
            onChange={(e: any) => {
              setMemberIdPrefixes(e.value.map((item: any) => item.trim()));
              onChange(e.value.map((item: any) => item.trim()));
            }}
            separator=","
          />
        )}
      />
    </div>
  );
}
